<template>
    <div style="background: radial-gradient(216.41% 100% at 50% 100%, #FFFFFF 0%, #FFF4EC 44.01%, #FFD5C0 56.72%, #FFE0BA 84.59%, #FFAF79 100%);">

    </div>
</template>

<script>

    export default {
        name: "TestModal",
        components: {},
        data(){
            return {
                map : null
            }
        },
        methods : {

        },
        mounted(){

        },
        created(){

        }
    }
</script>

<style scoped>

</style>